/**
 * Custom Site Specific Javascript
 *
 * This file is to add custom features to the website without having to modify
 * core/common assets. Define a custom class, and build new or overwrite
 * existing methods to create custom functionality.
 */

import { modal } from "commonAssets/lib/modal.js";
import { instruction } from "./Html/instructions";
import { attestation } from "./Html/attestation";

/**
 * Initializes a claim object.
 *
 * @param {Object} claim - The claim object to be initialized.
 * @returns {Object} The initialized claim object.
 */
export function customInitClaim(claim) {
    console.log("[Initiate claim]...");

    /**
     * Dom setup
     */
    document.getElementById("claimFormDeadline")?.remove();

    const generalInstructionsElement = document.querySelector("#generalInstructions > div");
    generalInstructionsElement.innerHTML = instruction;

    const attestationElement = document.querySelector("#certification > div:nth-child(2)");
    attestationElement.innerHTML = attestation;

    return claim;
}

/**
 * Custom function to load a member.
 *
 * @param {Object} claim - The member object to be loaded.
 * @returns {Object} - The loaded member object.
 */
export function customLoadMember(claim) {
    console.log("[Load class member]...");
    // custom code goes here
    return claim;
}

/**
 * Processes a claim for a custom member.
 *
 * @param {Object} claim - The claim to be processed.
 * @returns {Object} The processed claim.
 */
export function customProcessClaim(claim) {
    console.log("[Process claim]...");
    try {
        const fields = (claim && claim.inputs && claim.inputs.fields) || [];
        const productField =
            fields.find(
                (f) =>
                    f &&
                    (f.name === "number-of-products" ||
                        f.id === "number-of-products")
            ) ||
            document.querySelector('[name="number-of-products"]');

        const count = parseInt(productField?.value ?? "0", 10);
        const needsDocumentation = Number.isFinite(count) && count >= 5;

        if (needsDocumentation) {
            const hasUploads =
                (claim.uploads && claim.uploads.length > 0) ||
                (claim.class_member?.claim_files?.length > 0) ||
                (claim.data?.claim_files?.length > 0);

            if (!hasUploads) {
                claim.flags.valid = false;
                if (typeof modal === "function") {
                    modal(
                        "Supporting Documentation Required",
                        "Please upload supporting documentation because you are claiming 5 or more products."
                    );
                }
            }
        }
    } catch (error) {
        console.warn("Error validating documentation requirement", error);
    }
    return claim;
}
